<template>
  <div class="app-container userIndex">
    <el-card>
      <div slot="header" class="clearfix">
        <h3 class="pageName">{{ pageName }}</h3>
      </div>

      <el-form :model="pageQuery" ref="queryForm" :inline="true" size="small" class="box_form" >
        <el-form-item label="参数名称" prop="paramName">
          <el-input v-model="pageQuery.paramName" placeholder="请输入参数名称" clearable @keyup.enter.native="handleQuery" @change="$forceUpdate()" ></el-input>
        </el-form-item>

        <el-form-item label="添加时间" prop="date">
          <el-date-picker
            v-model="pageQuery.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery" >查询</el-button >
          <el-button icon="el-icon-refresh-left" @click="resetQuery" >重置</el-button >
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" element-loading-text="加载中" :data="list">
        <el-table-column label="序号" align="center" type="index" width="50" />
        <el-table-column label="参数名称" align="center" prop="paramName" />
        <el-table-column label="参数类型" align="center" prop="paramType">
          <template slot-scope="scope">
            {{ scope.row.paramType | getParamType }}
          </template>
        </el-table-column>
		<el-table-column label="参数值" align="center" prop="bussParamValue">
			<template slot-scope="scope">
				{{ decodeURIComponent(scope.row.bussParamValue) }}
			</template>
		</el-table-column>
        <el-table-column label="启用/关闭" align="center" prop="isEnable" width="100" >
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isEnable" active-value="1" inactive-value="0" @change="changeSwitch(scope.row)" ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" align="center" prop="createTime" ></el-table-column>
        <el-table-column label="添加人" align="center" prop="createBy" ></el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" >
          <template slot-scope="scope">
            <el-button size="small" plain type="primary" @click="handleEdit(scope.row)" >编辑</el-button >
            <el-button size="small" plain type="danger" @click="handleDel(scope.row)" >删除</el-button >
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :page.sync="pageQuery.pageNum" :limit.sync="pageQuery.pageSize" @pagination="getParamConfigList" />

      <el-dialog :title="form.paramId ? '编辑参数' : '添加参数'" :visible.sync="dialogShow" width="800px" append-to-body >
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="参数类型:" prop="paramType">
            <el-radio-group v-model="form.paramType">
              <el-radio :label="1">图片</el-radio>
              <el-radio :label="2">文本</el-radio>
              <el-radio :label="3">富文本</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="参数名称:" prop="paramName">
            <el-input v-model="form.paramName" placeholder="请输入参数名称" />
          </el-form-item>
          <el-form-item label="参数值:" prop="bussParamValue">
            <div v-if="form.paramType == 1">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :headers="headers"
                :show-file-list="false"
                :on-success="handleSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="form.bussParamValue" :src="form.bussParamValue" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div v-if="form.paramType == 2">
              <el-input v-model="form.bussParamValue" placeholder="请输入参数值" />
            </div>
            <div v-if="form.paramType == 3">
              <editor v-model="form.bussParamValue" :height="400"/>
            </div>
          </el-form-item>

          <el-form-item label="启用/关闭:" prop="isEnable">
            <el-switch v-model="form.isEnable" active-value="1" inactive-value="0" > </el-switch>
            <span>默认是启用状态，可使用，如关闭则不能使用</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('form')">取 消</el-button>
          <el-button type="success" @click="submitForm('form')" >确 定</el-button >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  paramConfigList,
  paramConfigUpdateIsEnable,
  bizParamConfig,
  delParamConfig,
} from "@/api/sportManage/basic";

import store from "@/store/index";
export default {
  name: "basicParam",
  data() {
    return {
      pageName: "参数设置",
      uploadUrl: process.env.VUE_APP_BASE_API + "/api/file/uploadOss", // 上传的图片服务器地址
      headers: {
        system: 0,
        token: store.state.token,
      },
      pageQuery: {
        pageNum: 1,
        pageSize: 10,
        time: [],
      },
      list: [],
      form: {},
      total: 0,
      loading: false,
      dialogShow: false,
      rules: {
        paramType: [
          { required: true, message: "请选择参数类型", trigger: "change" },
        ],
        paramName: [
          { required: true, message: "请输入参数名称", trigger: "change" },
        ],
        bussParamValue: [
          { required: true, message: "请输入参数值", trigger: "change" },
        ],
        isEnable: [
          { required: true, message: "请输入启用/关闭", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getParamConfigList();
  },
  methods: {
    handleQuery() {
      console.log(this.pageQuery);
      this.pageQuery.startTime = this.pageQuery.date
        ? this.pageQuery.date[0]
        : "";
      this.pageQuery.endTime = this.pageQuery.date
        ? this.pageQuery.date[1]
        : "";
      this.pageQuery.pageNum = 1;
      this.getParamConfigList();
    },
    async getParamConfigList() {
      let res = await paramConfigList({
        ...this.pageQuery,
      });
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
      this.pageQuery.startTime = "";
      this.pageQuery.endTime = "";
      this.getParamConfigList();
    },
    handleSuccess(res, file) {
      this.$set(this.form, "bussParamValue", res.data.url);
    },
    beforeAvatarUpload() {},
    async changeSwitch(row) {
      let res = await paramConfigUpdateIsEnable({
        paramId: row.paramId,
        isEnable: row.isEnable,
      });
      if (res.code === 200) {
        this.getParamConfigList();
      }
    },
    handleEdit(row) {
      console.log(row);
      this.dialogShow = true;
      if(row.paramType == 2) row.bussParamValue = decodeURIComponent(row.bussParamValue)
      this.form = {
        ...row,
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data = {
            ...this.form,
          };
          if(data.paramType == 2) data.bussParamValue = encodeURIComponent(data.bussParamValue)
          let res = null;
          if (data.paramId) {
            // 编辑
            res = await bizParamConfig(data);
          } else {
            // 增加
            // res = await deviceTypeAdd(data);
          }
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogShow = false;
            this.getParamConfigList();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogShow = false;
    },
    async handleDel(row) {
      this.$confirm(`确定删除该参数配置？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delParamConfig({
            paramIds: row.paramId,
          });
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.getParamConfigList();
        })
        .catch(() => {});
    },
  },
  filters: {
    getParamType(type) {
      switch (type) {
        case 1:
          return "图片";
        case 2:
          return "文本";
        case 3:
          return "富文本";
        default:
          return "暂无处理";
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/common.scss";

.userIndex {
  padding: 40px 40px;
  color: #676a6c;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  overflow-x: hidden;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  border: 1px dashed #f2f2f2;
}
.avatar {
  width: 128px;
  height: 128px;
  display: block;
  border: 1px dashed #f2f2f2;
}
</style>